<template>
  <div v-if="loading">

  </div>
  <div v-else-if="activeOrder.OrderId === 0" class="d-flex justify-content-center">
    <b-card title="404" class="p-5">
      <b-card-text>Error - Order not found</b-card-text>
    </b-card>
  </div>
  <div v-else>
    <b-card>
      <!-- Row 1 -->
      <b-row class="align-items-center pb-3 my-1">
        <b-col md="8">
          <h5>
            <span
              v-if="_hasHistory()"
              class="mr-4 primary-color back-btn"
              @click="$router.back()"
              data-cy="order-summary-back-btn"
            >
              <b-icon icon="arrow-left"></b-icon>
            </span>
            <i class="fa fa-truck fa-lg mr-2"></i>TPI Order Summary
          </h5>
        </b-col>
        <b-col md="4 my-1" style="text-align: right;">
          <span class="rounded border p-2" style="background-color: #d6eaf8">
            <b>{{ activeOrder.OrderStatus }}</b>
            <span v-if="orderRejectReason"> Reason: {{ orderRejectReason }}</span>
          </span>
          <b-btn variant="outline-primary" class="m-2" v-if="_isCustomerAdminSite() && activeOrder.OrderStatus == orderStatus.PENDING" @click="showChangeOrderWindow" v-hideIf.cantExecute="{ module: Modules.OrderAdmin }">Change Order</b-btn>
          <b-modal v-model="showChangeOrderModal" title="Update Order" size="md" v-if="_isCustomerAdminSite()" centered>
            <b-row class="m-3">
              <div class="col-md-12 table-responsive" v-if="orderInventories && orderInventories.length > 0">
                  <table class="table table-striped table-sm table-bordered">
                    <thead>
                      <tr>
                        <th>Line Number</th>
                        <th>Catalog Number</th>
                        <th>Inventory</th>
                        <th>Locations</th>
                        <th>Customer Material No</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(inventory) in orderInventories" :key="inventory.ItemNumber">
                        <td>
                          {{ inventory.ItemNumber }}
                        </td>
                        <td>
                          {{ inventory.MaterialNumber }}
                        </td>
                        <td>
                          {{ inventory.Inventory }}
                        </td>
                        <td>
                          {{ getInventoryLocations(inventory.StorageLocationQuantities) }}
                        </td>
                        <td>
                          <b-form-input
                            type="text"
                            class="form-control"
                            v-model="inventory.CustomerMaterialNumber"
                            maxlength="132"
                            @input="customerMaterialUpdated(inventory)"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
              <div class="col-md-12 mt-2">
                <div class="row">
                  <label class="col-md-4">Storage Location:</label>
                  <div class="col-md-8">
                    <b-form-select
                      id="shipping-method-dropdown"
                      class="form-control"
                      v-model="storageLocation"
                    >
                      <b-form-select-option
                        v-for="method in storageLocations"
                        :key="method"
                        :value="method"
                      >
                        {{ method }}
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2">
                <div class="row">
                  <label class="col-md-4">Expected Shipping Date:</label>
                  <b-input-group class="col-md-8">
                    <b-input-group-prepend>
                      <b-form-datepicker
                        v-model.trim="expectedShippingDate"
                        button-only
                        size="sm"
                        locale="en-US"
                        button-variant="link"
                        :min="minExpectedShippingDate"
                      ></b-form-datepicker>
                    </b-input-group-prepend>
                    <b-form-input
                      v-model.trim="expectedShippingDate"
                      type="text"
                      size="sm"
                      placeholder="YYYY-MM-DD"
                      autocomplete="off"
                      debounce="1000"
                    ></b-form-input>
                  </b-input-group>
                </div>
              </div>
              <div class="col-md-12 mt-2">
                <div class="row">
                  <label class="col-md-4">Incoterms:</label>
                  <div class="col-md-8">
                    <div class="form-group row">
                      <div class="col-md-6 mr-0 pr-0">
                        <b-form-select
                          v-model="inco1"
                          :class="{
                            'is-invalid': errors.inco1,
                          }"
                        >
                          <b-form-select-option
                            :value="null"
                          >
                            Select Any
                          </b-form-select-option>
                          <b-form-select-option
                            :value="'Best Way'"
                          >
                            Best Way
                          </b-form-select-option>
                          <b-form-select-option
                            v-for="method in incoTerms"
                            :options="incoTerms"
                            value-field="Inco1"
                            text-field="Inco1"
                            :key="method.Inco1"
                            :value="method.Inco1"
                          >
                            {{ method.Inco1 }} - {{ method.Description }}
                          </b-form-select-option>
                      </b-form-select>
                      </div>
                      <div class="col-md-6 m-0 p-0" v-show="inco1 !== 'Best Way'">
                          <b-form-input
                            v-model="inco2"
                            type="text"
                            placeholder="Inco2"
                            :class="{
                              'is-invalid': errors.inco2,
                            }"
                          />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2">
                <div class="row">
                  <template v-if="inco1and2">
                    <label>Shipping Instructions:</label>
                    <b-form-input sm :value="shippingMethod" disabled></b-form-input>
                  </template>
                  <template v-if="orderItemNotes.length">
                    <template v-for="(comment, i) in orderItemNotes">
                      <b-form-input sm :value="comment" :key="i" disabled></b-form-input>
                    </template>
                    <label class="col-md-12 text-secondary small">*Customer material numbers greater than 35 letters will be added as a comment.</label>
                  </template>
                </div>
              </div>
            </b-row>
            <template #modal-footer>
              <b-btn variant="primary" @click="changeOrderClick">Update Order</b-btn>
              <b-btn variant="secondary" @click="() => showChangeOrderModal = false">Cancel</b-btn>
            </template>
          </b-modal>

          <b-btn variant="outline-danger" v-if="_isCustomerAdminSite() && activeOrder.OrderStatus == orderStatus.PENDING" @click="() => showCancelOrderModal = true" v-hideIf.cantDelete="{ module: Modules.OrderAdmin }">Cancel</b-btn>
          <b-btn variant="outline-danger" v-if="_isCustomerAdminSite() && activeOrder.OrderStatus == orderStatus.IN_PROGRESS" @click="() => showCancelOrderModal = true" v-hideIf.cantDelete="{ module: 100 }">Cancel</b-btn>
          <b-modal v-model="showCancelOrderModal" title="Cancel Order" size="md" v-if="_isCustomerAdminSite()" centered>
            <b-row class="m-3">
              <div class="col-md-12">
                <div class="row">
                  <label class="col-md-4">Reason:</label>
                  <div class="col-md-8">
                    <b-form-select
                      id="shipping-method-dropdown"
                      class="form-control"
                      v-model="rejectReason"
                    >
                      <b-form-select-option
                        v-for="reason in OrderRejectReasons"
                        :key="reason.Code"
                        :value="reason.Code"
                      >
                        {{ reason.Text }}
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                </div>
              </div>
              <div class="col-md-12 mt-2">
                <div class="row">
                  <label class="col-md-4">Comment:</label>
                  <div class="col-md-8">
                    <b-form-input
                      maxlength="130"
                      v-model="rejectComment"
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </b-row>
            <template #modal-footer>
              <b-btn variant="danger" @click="cancelOrderClick">Cancel Order</b-btn>
              <b-btn variant="secondary" @click="() => showCancelOrderModal = false">Cancel</b-btn>
            </template>
          </b-modal>
        </b-col>
      </b-row>

      <!-- Row 2 -->
      <b-row
        class="justify-content-between align-items-center p-1 border-y"
        style="
          background-color: #e7f0f8;
          border-color: #a6c2ef;
          margin-left: -1.25rem;
          margin-right: -1.25rem;
        "
      >
        <b-col><b>Order Details</b></b-col>
      </b-row>

      <!-- Row 4 -->
      <b-row class="my-3">
        <b-col md="4" class="info-section" style="border-color: #a6c2ef" data-cy="order-summary-info">
          <b-col class="info-section-header" sm="border-top">Information</b-col>
          <b-row class="my-2 border-top pt-2">
            <b-col cols="6">Sale Order # :</b-col>
            <b-col cols="6"
              ><u
                ><b>{{ activeOrder.SalesOrderNumber }}</b></u
              ></b-col
            >
          </b-row>
          <b-row class="my-2">
            <b-col cols="6">Sales Order Date :</b-col>
            <b-col cols="6">{{ formatDate(activeOrder.OrderDate) }}</b-col>
          </b-row>
          <b-row class="my-2" v-if="_isSalesRepSite(site.Name) || _isCustomerSite(site.Name) || _isCustomerAdminSite()">
            <b-col cols="6">PO Number :</b-col>
            <b-col cols="6">{{
              activeOrder.CustomerPurchaseOrderNumber
            }}</b-col>
          </b-row>
          <b-row class="my-2" v-if="(_isSalesRepSite(site.Name) || _isCustomerSite(site.Name) || _isCustomerAdminSite()) && (activeOrder.CreatorUsername || activeOrder.Creator)">
            <b-col cols="6">Creator :</b-col>
            <b-col cols="6"><span :title="activeOrder.CreatorUsername">{{
              activeOrder.Creator ? activeOrder.Creator : activeOrder.CreatorUsername
            }}</span></b-col>
          </b-row>
          <b-row class="my-2" v-if="(_isSalesRepSite(site.Name) || _isCustomerSite(site.Name) || _isCustomerAdminSite()) && (activeOrder.SalesRepresentatives && activeOrder.SalesRepresentatives.length > 0)">
            <b-col cols="6">Sales Representative:</b-col>
            <b-col cols="6">
              <span v-for="(salesRep, index) in activeOrder.SalesRepresentatives" :key="salesRep">{{ salesRep }}<template v-if="index < activeOrder.SalesRepresentatives.length - 1">, </template></span>
            </b-col>
          </b-row>
          <b-row
            class="my-2"
            v-if="
              activeOrder.Deliveries == null ||
              activeOrder.Deliveries.length == 0
            "
          >
            <b-col cols="6">Expected Shipping Date :</b-col>
            <b-col cols="6" v-if="activeOrder.ExpectedShippingDate">{{
              formatDate(activeOrder.ExpectedShippingDate)
            }}</b-col>
          </b-row>
          <b-row class="my-2" v-else>
            <b-col cols="6">Tracking:</b-col>
            <b-col cols="6"><b-button variant="link" class="p-0" @click="tabIndex = OrderSummaryTabs.Deliveries">View Deliveries</b-button></b-col>
          </b-row>
        </b-col>

        <b-col md="2" class="info-section" style="border-color: #a6c2ef" data-cy="order-summary-value">
          <b-col class="info-section-header">Value</b-col>
          <b-row class="my-2 border-top pt-2">
            <b-col cols="6">Subtotal :</b-col>
            <b-col cols="6" class="text-right" lg="text-right">{{
              formatCost(activeOrder.Total)
            }}</b-col>
          </b-row>
          <b-row class="my-2" v-if="activeOrder.TaxCalculated">
            <b-col cols="6">Sales Tax :</b-col>
            <b-col cols="6" class="text-right">{{
              formatCost(activeOrder.Tax || 0)
            }}</b-col>
          </b-row>
          <b-row class="my-2">
            <b-col cols="6"
              >{{
                activeOrder.TaxCalculated
                  ? 'Grand Total'
                  : 'Estimated Total Before Tax'
              }}
              :</b-col
            >
            <b-col cols="6 font-weight-bold" class="text-right">{{
              formatCost(grandTotal)
            }}</b-col>
          </b-row>
        </b-col>

        <b-col
          md="3"
          class="info-section"
          style="border-color: #a6c2ef"
          v-if="activeOrder.BillToParty"
          data-cy="order-summary-bill-to"
        >
          <b-col class="info-section-header">Bill To</b-col>
          <b-row class="my-2 border-top pt-2">
            <b-col cols="6">Party :</b-col>
            <b-col cols="6">{{ activeOrder.BillToParty.Name }}</b-col>
          </b-row>
          <b-row class="my-2">
            <b-col cols="6">Phone # :</b-col>
            <b-col cols="6">{{ activeOrder.BillToParty.Phone }}</b-col>
          </b-row>
          <b-row class="my-2">
            <b-col cols="6">Address :</b-col>
            <b-col cols="6">{{
              `${activeOrder.BillToParty.Address1}, ${activeOrder.BillToParty.Address2}
              ${activeOrder.BillToParty.City}, ${activeOrder.BillToParty.State} ${activeOrder.BillToParty.Zip}
              `
            }}</b-col>
          </b-row>
          <b-row class="my-2" v-if="(_isSalesRepSite(site.Name) || _isCustomerAdminSite()) && activeOrder.AuthorizationNumber">
            <b-col cols="6">Authorization No :</b-col>
            <b-col cols="6">
              {{ activeOrder.AuthorizationNumber }}
            </b-col>
          </b-row>
        </b-col>

        <b-col md="3" class="info-section" v-if="activeOrder.ShipToParty" data-cy="order-summary-ship-to">
          <b-col class="info-section-header">Ship To</b-col>
          <b-row class="my-2 border-top pt-2">
            <b-col cols="6">Party :</b-col>
            <b-col cols="6">{{ activeOrder.ShipToParty.Name }}</b-col>
          </b-row>
          <b-row class="my-2">
            <b-col cols="6">Phone # :</b-col>
            <b-col cols="6">{{ activeOrder.ShipToParty.Phone }}</b-col>
          </b-row>
          <b-row class="my-2">
            <b-col cols="6">Address :</b-col>
            <b-col cols="6">{{
              `${activeOrder.ShipToParty.Address1}, ${activeOrder.ShipToParty.Address2}
              ${activeOrder.ShipToParty.City}, ${activeOrder.ShipToParty.State} ${activeOrder.ShipToParty.Zip}
              `
            }}</b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-tabs align="left" v-model="tabIndex">
        <b-tab title="Items">
          <template #title>
            Items ({{ totalSelectedQty }})
          </template>
          <div style="margin: -1.25rem">
            <item-table
              class="my-3"
              :fields="fields"
              :items="items"
              :selectedRows="selectedRows"
              :selectedItems="selectedItems"
              :disableInput="true"
            />
          </div>
        </b-tab>
        <b-tab title="Files" v-if="site.ManageDocuments">
          <template #title>
            Files <span v-if="!documentsLoading">({{ orderDocuments.length }})</span><span v-else><i class="fa fa-spinner fa-pulse"></i></span>
          </template>
          <div style="item-table-container my-3" v-show="documentsLoading">
              <h2><i class="fa fa-spinner fa-pulse"></i></h2>
          </div>
          <div style="margin: -1.25rem" v-show="!documentsLoading">
            <div class="item-table-container my-3">
              <b-table
                :fields="fileFields"
                :items="orderDocuments"
                responsive
                hover
                borderless
                sticky-header
                class="item-table"
                style="min-height: 200px;"
              >
                <template v-slot:cell(Name)="{ item }">
                  <b-link :href="'/api/order/document/' + item.Id + '?h=' + item.Hash" target="_blank">
                    {{ item.Name }}<template v-if="item.SectionCount == 1">{{ item.FileExtension }}</template>
                  </b-link>
                  <span v-if="item.SectionCount > 1"> ({{ item.SectionCount }} Files)</span>
                </template>
              </b-table>
              <b-button variant="primary" @click="() => { showOrderDocuments = true }" class="ml-3" v-if="site.ManageDocuments >= 2">
                <template v-if="site.ManageDocuments == 2">Upload files</template>
                <template v-else-if="site.ManageDocuments == 3">Manage files</template>
              </b-button>
              <b-modal v-model="showOrderDocuments" title="Order Documents" size="xl" ok-only>
                <order-documents :orderDocuments="orderDocuments" :showFileUpload="site.ManageDocuments >= 2" :showClipUnclip="site.ManageDocuments === 3" :showDelete="site.ManageDocuments === 3"
                @upload="upload"
                @clip="clip"
                @delete="deleteFile"
                @unclip="unclip"
                ></order-documents>
                <template #modal-footer>&nbsp;</template>
              </b-modal>
            </div>
          </div>
        </b-tab>
        <b-tab :title="`Comments (${activeOrder.Comments.length})`" v-if="_isSalesRepSite(site.Name) || _isCustomerAdminSite()">
          <b-row class="my-2">
            <b-col cols="12" v-for="(comment, index) in activeOrder.Comments" :key="'comment-'+index">
              <i>{{ comment }}&nbsp;</i>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab v-if="activeOrder.Deliveries.length > 0" :title="`Deliveries (${activeOrder.Deliveries.length})`" >
          <b-row class="my-2">
            <b-col cols="12" md="4" class="pb-2" v-for="(delivery) in activeOrder.Deliveries" :key="'delivery-'+delivery.DeliveryId">
              <b-card class="h-100">
                <b-card-title><h5>{{ delivery.Carrier }}</h5></b-card-title>
                <b-card-sub-title>
                  <template v-if="delivery.ShippingInformation && delivery.ShippingInformation.TrackingUpdatesList?.length > 0">
                    <div class="d-flex align-items-center">
                      <span>Tracking: </span>
                      <b-button
                        @click="() => setSelectedShippingInformation(delivery.ShippingInformation, delivery.TrackingNumber)"
                        variant="link p-0 ml-1"
                        :key="delivery.DeliveryId"
                        >{{ delivery.TrackingNumber }}
                      </b-button>
                    </div>
                  </template>
                  <template v-else>
                    Tracking: {{ delivery.TrackingNumber }}
                  </template>
                </b-card-sub-title>
                <b-card-text>
                  <div v-if="delivery.ShippingInformation && delivery.ShippingInformation.TrackingUpdatesList?.length > 0">
                    Status: <b>{{ delivery.ShippingInformation.TrackingUpdatesList[0]?.Status }}</b> <br/>
                    Last Updated: {{ formatDeliveryDate(delivery.ShippingInformation.TrackingUpdatesList[0]?.Date.toString()) }}
                  </div>
                </b-card-text>
                <b-card-text v-if="delivery.Items.length > 0">
                  Items:
                  <ul v-for="(item, i) in delivery.Items" :key="delivery.DeliveryId+'=item-'+i">
                    <li><b>{{ item.Quantity }}</b> <b-icon icon="x" class="color-primary"></b-icon> {{ item.ShortText }} (<b>{{ item.Material }}</b>)</li>
                  </ul>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </b-card>
    <div class="d-flex justify-content-center">
      <b-button
        block
        variant="outline-primary"
        class="primary-outline-btn my-3"
        @click="$router.push({ name: 'home' })"
      >
        Close summary
      </b-button>
    </div>
    <order-tracking
     :shippingInformation="selectedShippingInformation"
     :trackingNumber="selectedTrackingNumber"
     @close="() => { selectedShippingInformation = undefined;  selectedTrackingNumber = ''}"></order-tracking>
  </div>
</template>

<script lang="ts">
import ItemTable from '@/components/table/item-table.vue'
import LoadingText from '@/components/utility/loading.vue'
import { CartItem } from '@/store/cart/types'
import { OrderStatus } from '@/store/orders/constants'
import { IOrder, ShippingInformation, IOrderDocument, IChangeOrder } from '@/store/orders/types'
import dayjs from 'dayjs'
import { Component, Mixins, Watch } from 'vue-property-decorator'
import OrderTracking from '@/components/order-tracking/order-tracking.vue'
import OrderDocuments from '@/components/orders/order-documents.vue'
import { namespace } from 'vuex-class'
import MxSite from '@/mixins/site'
import { isCustomerAdminSite } from '@/helpers/sites.helper'
import businessDays from 'business-days-js'
import dayjsPluginUTC from 'dayjs/plugin/utc'
dayjs.extend(dayjsPluginUTC)

const nsOrders = namespace('orders')
const nsCommon = namespace('common')

@Component({
  components: {
    ItemTable,
    LoadingText,
    'order-tracking': OrderTracking,
    'order-documents': OrderDocuments,
  },
})
export default class OrderSummary extends Mixins(MxSite) {
  @nsOrders.State('activeOrder')
  public activeOrder!: IOrder

  @nsOrders.State('orderDocuments')
  public orderDocuments!: IOrderDocument[]

  @nsOrders.State('documentsLoading')
  public documentsLoading!: boolean

  @nsOrders.State('documentsError')
  public documentsError!: string

  @nsOrders.State('submissionError')
  private submissionError!: string

  public selectedShippingInformation: ShippingInformation | any = { isBlank: true }

  public selectedTrackingNumber = ''

  public showOrderDocuments = false

  @nsOrders.Action('changeOrder')
  private changeOrder: any

  @nsOrders.Action('fetchOrderInventories')
  private fetchOrderInventories: any

  @nsOrders.Action('setActiveOrder')
  private setActiveOrder: any

  @nsOrders.Action('fetchOrder')
  private fetchOrder: any

  @nsOrders.Action('fetchDocuments')
  private fetchDocuments: any

  @nsOrders.Action('uploadDocuments')
  public uploadDocuments: any

  @nsOrders.Action('clipDocuments')
  public clipDocuments: any

  @nsOrders.Action('unclipDocuments')
  public unclipDocuments: any

  @nsOrders.Action('deleteDocuments')
  public deleteDocuments: any

  @nsCommon.Getter('storageLocations')
  private storageLocations: any

  @nsCommon.Action('fetchStorageLocations')
  private fetchStorageLocations: any

  @nsCommon.Getter('incoTerms')
  private incoTerms: any

  @nsCommon.Action('fetchIncoTerms')
  private fetchIncoTerms: any

  public items: CartItem[] = []
  public orderStatus = OrderStatus
  public tabIndex = 0
  public showChangeOrderModal = false
  public showCancelOrderModal = false

  public OrderSummaryTabs: any = {
    Items: 0,
    Files: 1,
    Comments: 2,
    Deliveries: 3,
  }

  public OrderRejectReasons: any = [
    { Code: '01', Text: 'Customer\'s choice' },
    { Code: '02', Text: 'Item change' },
    { Code: '03', Text: 'Delivery too late' },
    { Code: '04', Text: 'Competitor better' },
    { Code: '05', Text: 'Customer service error' },
    { Code: '06', Text: 'Discontinued item' },
    { Code: '07', Text: 'Factory cannot produce' },
    { Code: '08', Text: 'Technical change' },
    { Code: '09', Text: 'Too expensive' },
    { Code: '10', Text: 'Customer quoted wrong price' },
  ]

  public changeOrderValidations = {
    StorageLocation: true,
    ExpectedShippingDate: true,
    Inco1: true,
    Inco2: true,
  }

  public minExpectedShippingDate = this.formatDate(dayjs(new Date()))
  public expectedShippingDate = this.formatDate(dayjs(new Date()))
  public orderInventories: any = []
  public orderItemNotes: any = []
  public storageLocation: any = '9900'
  public inco1: any = null
  public inco2 = ''
  public rejectReason = '05'
  public rejectComment = ''
  public errors: any = {
    inco1: false,
    inco2: false,
  }

  public mounted() {
    if (this._isCustomerAdminSite()) {
      this.fetchStorageLocations()
      this.fetchIncoTerms()
    }
  }

  public get inco1and2() {
    if (this.inco1 === 'Best Way') {
      return this.inco1
    } else if (this.inco1 && this.inco2) {
      return this.inco1 + ' ' + this.inco2
    }
    return null
  }

  public get shippingMethod() {
    return 'Shipping Method: ' + this.inco1and2
  }

  public get orderRejectReason() {
    return this.OrderRejectReasons.find(s => s.Code === this.activeOrder.RejectReason)?.Text
  }

  public showChangeOrderWindow() {
    this.showChangeOrderModal = true
    this.orderInventories = []
    this.fetchOrderInventories(this.activeOrder.SalesOrderNumber).then((result: any) => {
      this.orderInventories = result.Items

      const leadTime = Math.max(...result.Items.map(s => s.LeadTime || 0))
      const bDays = businessDays({ state: 'tn' })
      const startDate = new Date()
      this.minExpectedShippingDate = this.formatDate(bDays.addDays(startDate, leadTime))
      this.expectedShippingDate = this.minExpectedShippingDate
    })
  }

  public getInventoryLocations(storageLocations: any) {
    return storageLocations?.map(m => m.Location + ': ' + m.Quantity).join(', ')
  }

  public validate() {
    let valid = true
    this.errors.inco1 = false
    this.errors.inco2 = false
    if (this.inco1 !== 'Best Way') {
      if (!this.inco1) {
        this.errors.inco1 = true
        valid = false
      }
      if (!this.inco2) {
        this.errors.inco2 = true
        valid = false
      }
    }
    return valid
  }

  public changeOrderClick() {
    if (!this.validate()) {
      return
    }
    const request: IChangeOrder = {
      SalesOrderNumber: this.activeOrder.SalesOrderNumber,
      Cancel: false,
      ExpectedShippingDate: this.expectedShippingDate,
      StorageLocation: this.storageLocation,
      Inco1: this.inco1,
      Inco2: this.inco2,
      OrderItems: [],
      OrderCustomerShippingText: [this.shippingMethod, ...this.orderItemNotes],
    }
    this.orderInventories.forEach((inventory: any) => {
      request.OrderItems?.push({
        ItemNumber: inventory.ItemNumber,
        CustomerMaterialNumber: inventory.CustomerMaterialNumber,
      })
    })
    this.changeOrder(request).then(() => {
      this.showChangeOrderModal = false
    })
  }

  public cancelOrderClick() {
    const request: IChangeOrder = {
      SalesOrderNumber: this.activeOrder.SalesOrderNumber,
      Cancel: true,
    }
    request.RejectReason = this.rejectReason
    request.RejectComments = this.rejectComment
    this.changeOrder(request).then(() => {
      this.showCancelOrderModal = false
    })
  }

  @Watch('orderInventories', { deep: true })
  public customerMaterialUpdated() {
    this.orderItemNotes = this.orderInventories.filter(s => s.CustomerMaterialNumber && s.CustomerMaterialNumber.length > 35).map(s => 'Line item ' + (s.ItemNumber.replace(/^0+/g, '')) + ': ' + s.CustomerMaterialNumber!)
  }

  public get isMobile() {
    return window.innerWidth <= 1024
  }

  public upload(files: any) {
    this.showOrderDocuments = false
    this.uploadDocuments({ orderNumber: this.activeOrder.SalesOrderNumber, files })
  }

  public clip(documentIds: any) {
    this.showOrderDocuments = false
    this.clipDocuments({ orderNumber: this.activeOrder.SalesOrderNumber, documentIds })
  }

  public unclip(documentId: any) {
    this.showOrderDocuments = false
    this.unclipDocuments({ orderNumber: this.activeOrder.SalesOrderNumber, documentId })
  }

  public deleteFile(documentId: any) {
    this.showOrderDocuments = false
    this.deleteDocuments({ orderNumber: this.activeOrder.SalesOrderNumber, documentId })
  }

  public fileFields = [
    {
      key: 'checkbox',
      label: '',
      thClass: 'responsive-col-size text-left',
      tdClass: 'responsive-col-size text-left',
    },
    {
      key: 'Name',
      label: 'Name',
      thClass: 'responsive-col-size text-left',
      tdClass: 'responsive-col-size text-left',
    },
    {
      key: 'CreateDate',
      label: 'CreateDate',
      thClass: 'text-left',
      tdClass: 'responsive-col-size text-left',
      thStyle: 'resp-th-30',
      formatter: (val: any) => {
        return this.formatDate(val)
      },
    },
    {
      key: 'Size',
      label: 'Size (kb)',
      thClass: 'text-left',
      tdClass: 'responsive-col-size text-left',
      thStyle: 'resp-th-30',
      formatter: (val: any) => {
        return (val / 1024).toFixed(0)
      },
    },
  ]

  public fields = [
    {
      key: 'details',
      label: 'Toggle Details',
      thClass: 'responsive-col-hide text-left',
      tdClass: 'responsive-col-hide text-left',
      thStyle: { width: '10%' },
    },
    {
      key: 'imgThumbnail',
      label: '',
      thClass: 'responsive-col text-left',
      tdClass: 'responsive-col text-left',
      thStyle: { width: '5%' },
    },
    {
      key: 'itemNumber',
      label: 'Item Number',
      thClass: 'text-left',
      tdClass: 'responsive-col-size text-left',
      thStyle: 'resp-th-30',
    },
    {
      key: 'pcnCatalogNumber',
      label: 'PCN',
      thClass: 'text-left',
      tdClass: 'responsive-col-size text-left',
      thStyle: 'resp-th-30',
    },
    {
      key: 'fingoodTpiMfgMod',
      label: 'Model #',
      thClass: 'text-left',
      tdClass: 'responsive-col-size text-left',
      thStyle: 'resp-th-40',
    },
    {
      key: 'description',
      label: 'Description',
      thClass: 'responsive-col text-left',
      tdClass: 'responsive-col text-left',
      thStyle: { width: '20%' },
    },
    {
      key: 'status',
      label: 'Status',
      thClass: 'responsive-col text-left',
      tdClass: 'responsive-col text-left',
      thStyle: { width: '10%' },
    },
    {
      key: 'price',
      label: 'Unit Price',
      thClass: 'responsive-col text-right',
      tdClass: 'responsive-col text-right',
      thStyle: { width: '10%' },
      formatter: (val: any) => {
        if (val == null) {
          return ''
        } else if (isNaN(val)) {
          return val
        } else {
          return `$${parseFloat(val).toFixed(2)}`
        }
      },
    },
    {
      key: 'quantity',
      label: 'Qty',
      thClass: 'responsive-col text-right',
      tdClass: 'responsive-col text-right',
      thStyle: { width: '10%', minWidth: '80px' },
    },
    {
      key: 'totalPrice',
      label: 'Total Price',
      thClass: 'text-right',
      tdClass: 'responsive-col-size text-right',
      thStyle: 'resp-th-20',
      formatter: (val: any) => {
        if (val == null) {
          return ''
        } else if (isNaN(val)) {
          return val
        } else {
          return `$${parseFloat(val).toFixed(2)}`
        }
      },
    },
  ]

  public selectAll = false

  public selectedRows: CartItem[] = []
  public loading = true

  public get grandTotal() {
    return this.activeOrder.Total + (this.activeOrder.Tax || 0.0)
  }

  @Watch('activeOrder')
  public handleOrderAdded() {
    this.items = [...this.activeOrder.Items]
    this.selectedRows = [...this.activeOrder.Items]
    if (this.activeOrder.Deliveries.length > 0 && this.activeOrder.Deliveries[0].ShippingInformation && this.activeOrder.Deliveries[0].ShippingInformation.TrackingUpdatesList?.length > 0) {
      this.tabIndex = this.OrderSummaryTabs.Deliveries
    }
  }

  @Watch('documentsError')
  public displayDocumentError() {
    if (this.documentsError) {
      this.toastError(this.documentsError)
    }
  }

  @Watch('submissionError')
  public alertSubmissionError(newError: any) {
    if (newError) {
      this.toastError(newError)
    }
    this.submissionError = ''
  }

  created() {
    window.scrollTo({
      top: 0,
      behavior: 'instant', // Optional: Add smooth scrolling animation
    })
    this.loading = true
    this.fetchOrder(this.$route.params.invoiceNo).then(async () => {
      this.items = [...this.activeOrder.Items]
      this.selectedRows = [...this.activeOrder.Items]
      this.loading = false
      if (this.activeOrder.Deliveries.length > 0 && this.activeOrder.Deliveries[0].ShippingInformation && this.activeOrder.Deliveries[0].ShippingInformation.TrackingUpdatesList?.length > 0) {
        this.tabIndex = this.OrderSummaryTabs.Deliveries
      }
    })
    if (this.site.ManageDocuments) {
      this.fetchDocuments(this.$route.params.invoiceNo)
    }
  }

  public get selectedItems(): CartItem[] {
    return this.items.filter((item) => this.selectedRows.includes(item))
  }

  public get totalSelectedQty(): number {
    return this.selectedItems.reduce((total, item) => total + item.quantity, 0)
  }

  public get totalSelectedPrice(): number {
    return this.selectedItems.reduce(
      (total, item) => total + item.quantity * item.price,
      0,
    )
  }

  public formatCost(cost: number): string {
    return `$${cost.toFixed(2)}`
  }

  public formatDate(date) {
    return dayjs(date).format('YYYY-MM-DD')
  }

  public setSelectedShippingInformation(information: ShippingInformation, trackingNumber: string) {
    this.selectedTrackingNumber = trackingNumber
    this.selectedShippingInformation = information
  }

  public formatDeliveryDate(date: string) {
    return dayjs.utc(date).local()
  }

  public _isCustomerAdminSite() {
    return isCustomerAdminSite(this.role)
  }
}
</script>

<style lang="scss">
.action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px 4px 8px;
  background-color: #f4f7f9;
  position: sticky;
  top: 0;
  z-index: 10;

  .selected-info {
    display: flex;
    align-items: center;
    gap: 20px;

    .items {
      width: 15vh;
      text-align: center;
      border-right: 1px solid #a6c2ef;
    }
  }
  .actions {
    float: right;
  }
}

.back-btn {
  cursor: pointer;
}

.info-section {
  border-top: 1px solid #dee2e6 !important;
  padding-top: 0.5rem;
  margin-bottom: 1rem;
  @media (min-width: 767px) {
    border-right: 1px solid #dee2e6 !important;
    border-top: none !important;
    padding-top: 0;
    margin-bottom: 0;
  }
  .info-section-header {
    color: #7c97b6;
    font-weight: bold;
    font-size: small;
  }
}
</style>
